var InputSize = /*#__PURE__*/function (InputSize) {
  InputSize[InputSize["Sm"] = 28] = "Sm";
  InputSize[InputSize["Md"] = 32] = "Md";
  InputSize[InputSize["Lg"] = 40] = "Lg";
  InputSize[InputSize["Xl"] = 58] = "Xl";
  return InputSize;
}({});
var InputVariant = /*#__PURE__*/function (InputVariant) {
  InputVariant["Filled"] = "filled";
  InputVariant["Outline"] = "outline";
  InputVariant["Simple"] = "simple";
  return InputVariant;
}({});

export { InputSize as I, InputVariant as a };
//# sourceMappingURL=types-arAyTUq_.js.map
